import React from "react";
import { useLocation } from "react-router-dom";

export const WHATSAPP_URL = "https://wa.me/447453421197?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20We%C2%B7Spik";

export const WhatsAppFloat = () => {
  const location = useLocation();

  if (location.pathname.startsWith("/panel")) {
    return null;
  }

  return (
    <div className="wsp-whatsapp-float" data-testid="whatsapp-float">
      <span className="wsp-whatsapp-label" data-testid="whatsapp-float-label">
        Escríbenos por WhatsApp para más información
      </span>
      <a
        className="wsp-whatsapp-button"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener"
        aria-label="Escríbenos por WhatsApp para más información"
        data-testid="whatsapp-float-link"
      >
        <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
          <path
            d="M16 3.25a12.7 12.7 0 0 0-10.98 19.1L3.5 28.75l6.57-1.49A12.75 12.75 0 1 0 16 3.25Zm0 23.18a10.37 10.37 0 0 1-5.28-1.45l-.38-.22-3.9.88.9-3.8-.25-.4A10.38 10.38 0 1 1 16 26.43Zm5.7-7.78c-.31-.16-1.85-.91-2.13-1.02-.29-.1-.5-.16-.71.16-.21.31-.81 1.02-.99 1.23-.18.21-.37.23-.68.08-.31-.16-1.31-.48-2.49-1.54a9.3 9.3 0 0 1-1.72-2.14c-.18-.31-.02-.48.14-.63.14-.14.31-.37.47-.55.15-.18.2-.31.31-.52.1-.21.05-.39-.03-.55-.08-.16-.71-1.7-.97-2.33-.26-.62-.52-.54-.71-.55h-.61c-.21 0-.55.08-.84.39-.29.31-1.1 1.08-1.1 2.63s1.12 3.05 1.27 3.26c.16.21 2.2 3.35 5.33 4.7.74.32 1.32.51 1.77.65.75.24 1.43.21 1.97.13.6-.09 1.85-.76 2.11-1.49.26-.73.26-1.36.18-1.49-.08-.13-.29-.21-.6-.36Z"
            fill="currentColor"
          />
        </svg>
      </a>
    </div>
  );
};